import { generateHourlyUrlParams } from './urlValidator';

/**
 * 현재 시간 기준으로 유효한 URL 생성
 * @param baseUrl 기본 URL (예: "https://example.com/contract")
 * @returns {string} 완전한 URL
 */
export const generateCurrentValidUrl = async (baseUrl: string): Promise<string> => {
  const params = await generateHourlyUrlParams();
  return `${baseUrl}${params}`;
};

/**
 * 특정 페이지의 현재 유효한 URL 생성
 * @param pagePath 페이지 경로 (예: "/contract", "/quiz1")
 * @returns {string} 완전한 URL
 */
export const generatePageUrl = async (pagePath: string): Promise<string> => {
  const baseUrl = window.location.origin + pagePath;
  return await generateCurrentValidUrl(baseUrl);
};

/**
 * 모든 주요 페이지의 현재 유효한 URL들을 생성
 * @returns {object} 페이지별 URL 객체
 */
export const generateAllPageUrls = async (): Promise<Record<string, string>> => {
  const pages = [
    '/',
    '/guide01',
    '/register', 
    '/contract',
    '/channel-open',
    '/tale-house',
    '/quiz1',
    '/quiz2',
    '/quiz3',
    '/quiz4',
    '/quiz5',
    '/quiz6',
    '/progress-card'
  ];

  const urls: Record<string, string> = {};
  
  for (const page of pages) {
    urls[page] = await generatePageUrl(page);
  }

  return urls;
};

/**
 * QR코드 데이터 URL을 생성하는 함수 (실제 QR 라이브러리 사용 시)
 * @param url QR코드로 변환할 URL
 * @returns {Promise<string>} QR코드 이미지의 data URL
 */
export const generateQRCodeDataUrl = async (url: string): Promise<string> => {
  // 실제 구현에서는 QR 라이브러리(예: qrcode)를 사용
  // 여기서는 예시로 빈 이미지를 반환
  return 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mNkYPhfDwAChwGA60e6kgAAAABJRU5ErkJggg==';
};

/**
 * 현재 시간 정보를 포맷팅
 * @returns {string} 포맷팅된 시간 문자열
 */
export const getCurrentTimeFormatted = (): string => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const day = String(now.getDate()).padStart(2, '0');
  const hour = String(now.getHours()).padStart(2, '0');
  const minute = String(now.getMinutes()).padStart(2, '0');
  
  return `${year}-${month}-${day} ${hour}:${minute}`;
};

/**
 * 다음 QR코드 갱신 시간을 포맷팅
 * @returns {string} 포맷팅된 시간 문자열
 */
export const getNextUpdateTimeFormatted = (): string => {
  const now = new Date();
  const nextHour = new Date(now);
  nextHour.setHours(now.getHours() + 1, 0, 0, 0);
  
  const year = nextHour.getFullYear();
  const month = String(nextHour.getMonth() + 1).padStart(2, '0');
  const day = String(nextHour.getDate()).padStart(2, '0');
  const hour = String(nextHour.getHours()).padStart(2, '0');
  const minute = String(nextHour.getMinutes()).padStart(2, '0');
  
  return `${year}-${month}-${day} ${hour}:${minute}`;
};
